<div style="height:100%; width: 100%; display: flex; flex-direction: column; align-items:center;">
	 <router-outlet></router-outlet>
</div>
